import DefaultNavbar from 'components/DefaultNavbar';
import DefaultFooter from 'components/DefaultFooter';
import DefaultHeader from 'components/DefaultHeader';
import MasjidTvContent from 'components/mobile-app/MasjidTvContent';
import MobileAppIcon from 'assets/img/masjid-tv/icon.png';
import SupportSection from 'components/mobile-app/SupportSection';

export default function MasjidTv() {
    return (
        <>
            <div className="absolute w-full z-20">
                <DefaultNavbar/>
            </div>
            <main>
                <DefaultHeader bg="bg-masjidtv-background" />
                <MasjidTvContent title="Masjid TV" icon={MobileAppIcon}/>
                <SupportSection />
            </main>
            <DefaultFooter />
        </>
    );
}
